// extracted by mini-css-extract-plugin
module.exports = {"date":"blog-module--date--147vx"};